import React, { useState } from "react";
import Chatbot from "layouts/Chatbot/smallChatbot";
import ChatIcon from "@mui/icons-material/Chat";
import CloseIcon from "@mui/icons-material/Close";

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [expanded, setIsExpandedChatWindow] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 9999 }}>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            bottom: "60px",
            right: "0px",
            width: expanded ? "0px" : "350px",
            height: "500px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "10px",
            boxShadow: "0 0 10px rgba(0,0,0,0.2)",
            overflow: "hidden",
          }}
        >
          <Chatbot
            isOpen={isOpen}
            messages={messages}
            setMessages={setMessages}
            setIsExpandedChatWindow={setIsExpandedChatWindow}
          />
        </div>
      )}
      <button
        onClick={toggleChat}
        style={{
          backgroundColor: "#1976d2",
          borderRadius: "50%",
          width: "50px",
          height: "50px",
          border: "none",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
        }}
      >
        {isOpen ? <CloseIcon /> : <ChatIcon />}
      </button>
    </div>
  );
};

export default ChatWidget;
